module.exports = __webpack_public_path__ + "static/media/downloadIcon.b0330aa1.svg";